module.exports = __webpack_public_path__ + "static/img/zijianCompany.811b0ec4.jpg";